import { configurationsStoreGetters } from "./store";

declare var AGOL_URL: string;

export class Config {
  public static arcgisPortal: string = "https://www.arcgis.com/sharing/rest/portals/self?f=json";
  public static clientSideUrl: string = `${window.location.origin}/`;
  public static geoemtriesServerUrl: string = AGOL_URL;
}
